import type { QueryFunctionContext } from '@tanstack/react-query';
import { requestWithAuth } from '@/utilities/graphQLClient';
import { gql } from 'graphql-request';
import { getQueryKey } from './usePortfolioPerformanceTimeseries';

export interface QueryResponse {
  errors?: Error[];
  Portfolio: {
    performance: Record<string, number>;
  };
}

type QueryContext = QueryFunctionContext<ReturnType<typeof getQueryKey>>;

export const queryFn = async ({
  queryKey: [_key, portfolioId, { startTimestamp, endTimestamp }],
}: QueryContext): Promise<Record<string, number>> => {
  const {
    Portfolio: { performance },
    errors,
  } = await requestWithAuth<QueryResponse>(
    gql`
      query getPortfolioPerformanceTimeseries(
        $portfolioId: String!
        $startTimestamp: Float!
        $endTimestamp: Float!
      ) {
        Portfolio(id: $portfolioId) {
          performance(
            startTimestamp: $startTimestamp
            endTimestamp: $endTimestamp
          )
        }
      }
    `,
    { portfolioId, startTimestamp, endTimestamp }
  );

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return performance;
};
